export default {
  SET_MASTERLIST: (state, data) => {
    state.masterlist = data;
  },
  SET_MASTERLIST_item: (state, data) => {
    state.masterlistItem = data;
  },
};
